<template>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <!-- :key="indexChart"                              -->
        <v-widget class="px-0" :title="titulo" content-bg="white">
          <div slot="widget-content">
            <e-chart
              :path-option="[
                ['dataset.source', res],
                [
                  'color',
                  [color.lightBlue.base, color.orange.base, color.grey.base],
                ],
                ['legend.show', true],
                ['xAxis.axisLabel.show', true],
                ['yAxis.axisLabel.show', true],
                ['grid.left', '2%'],
                ['grid.bottom', '5%'],
                ['grid.right', '3%'],
                //region 1
                ['series[0].type', 'bar'],
                ['series[0].areaStyle', {}],
                ['series[0].smooth', true],
                ['series[1].type', 'bar'],
                ['series[1].areaStyle', {}],
                ['series[1].smooth', true],
                ['series[2].type', 'bar'],
                ['series[2].areaStyle', {}],
                ['series[2].smooth', true],
              ]"
              height="400px"
              width="100%"
            ></e-chart>
            <!-- :path-option="[
                                ['dataset.source', res],
                                ['color', [color.lightBlue.base, color.orange.base, color.grey.base]],
                                ['legend.show', true],
                                ['xAxis.axisLabel.show', true],
                                ['yAxis.axisLabel.show', true],                               
                                ['grid.left', '2%'],
                                ['grid.bottom', '5%'],
                                ['grid.right', '3%'],
                                //region 1      
                                ['series[0].type', 'bar'],
                                ['series[0].areaStyle', {}],
                                ['series[0].smooth', true],
                                ['series[1].type', 'bar'],
                                ['series[1].areaStyle', {}],
                                ['series[1].smooth', true],
                                ['series[2].type', 'bar'],
                                ['series[2].areaStyle', {}],
                                ['series[2].smooth', true],                 
            ]"-->
          </div>
        </v-widget>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import API from "@/api";
import EChart from "@/components/chart/echart";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import axios from "axios";
import { mapState } from "vuex";
import CircleStatistic from "@/components/widgets/statistic/CircleStatistic";
import { misMixins } from "@/mixins/myMixing.js";

export default {
  name: "grafica-avance",

  props: {
    res: "",
    titulo: "",
    titleIn: "",
    //nivelFiltro:"",
    //regionFiltro:""
  },

  components: {
    VWidget,
    EChart,
    CircleStatistic,
  },

  mixins: [misMixins],
  data: () => ({
    color: Material,
  }),

  computed: {},

  created() {
    this.contratoId = this.$store.getters.contratoStored;
    this.subProceso = this.$store.getters.subProTabSelectedStored;
  },

  methods: {},
};
</script>
